import { render, staticRenderFns } from "./Sizes.vue?vue&type=template&id=ee35a18a&"
import script from "./Sizes.vue?vue&type=script&lang=js&"
export * from "./Sizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports